import React from 'react';

import { IconButton, Card, CardHeader, CloseIcon } from '@gogame/components';
import { FormField } from '@gogame/form';

const HybridLinkParameterItem = ({ name, onRemove }) => {
  return (
    <Card elevation={6}>
      <CardHeader
        action={
          <IconButton
            icon={<CloseIcon />}
            tooltip={'Remove'}
            onClick={onRemove}
          />
        }
      >
        <FormField.TextField
          label={'Parameter'}
          name={name}
          padding={0}
          required={true}
        />
      </CardHeader>
    </Card>
  );
};

export default HybridLinkParameterItem;
